module.exports = __webpack_public_path__ + "static/lucky_bun-f799d4a48520aa09b65a25431968d959.jpg";